import { useCallback, useEffect, useState } from 'react';

import type { SessionStorageEntries } from 'lib/storage/sessionStorage';
import { SESSION_STORAGE, sessionStorage } from 'lib/storage/sessionStorage';

export { SESSION_STORAGE };
export const useSessionStorage = <K extends keyof SessionStorageEntries>(
  key: K
): [
  SessionStorageEntries[K] | null,
  (value: SessionStorageEntries[K] | null) => void,
] => {
  const [state, setState] = useState(sessionStorage.getValue(key));

  useEffect(() => {
    const updateState = () => {
      setState(sessionStorage.getValue(key));
    };
    window.addEventListener('storage', updateState);
    return () => {
      window.removeEventListener('storage', updateState);
    };
  }, [key]);

  const setValueThenState = useCallback(
    (v: SessionStorageEntries[K] | null) => sessionStorage.setValue(key, v),
    [key]
  );

  return [state, setValueThenState];
};
